<template>
  <div>
    <div class="m-1 mt-3" id="helpCollapse">
      <div class="card">
        <div class="card-header m-0 p-0" id="headingOne">
          <h2 class="m-0 p-0">
            <button
              class="btn btn-link btn-block text-left text-primary"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              <i class="pull-left fa fa-question-circle"></i> Help
            </button>
          </h2>
        </div>
        <div
          id="collapseOne"
          class="collapse"
          aria-labelledby="headingOne"
          data-parent="#helpCollapse"
        >
          <div class="card-body">
            <h3>Results table</h3>
            <p>
              Below you will find a table of BLAST search results of your query
              sequence against proteins in our flexibility database. Each row
              contains a cluster hit and clicking on the left column will
              immediately forward you to
              <a href="pdbflex.org" target="blank">PDBFlex</a> to investigate
              the whole cluster in detail. In the right column you will see
              members of the whole cluster selected to be representatives for
              the structural flexibility found within the cluster.
            </p>

            <p>You can sort all returned clusters either by</p>
            <ul>
              <li>
                e-value : e-Value returned for that particular cluster with your
                search sequence
              </li>
              <li>
                Identity : sequence identity for that particular cluster with
                your search sequence
              </li>
              <li>
                RMSD : maximum intrinsic RMSD detected for that particular
                cluster
              </li>
              <li>
                # of subclusters : number of subclusters found particular
                cluster
              </li>
            </ul>

            <p class="bd-callout">
              Note: Click on the <i class="fa fa-info-circle"></i> icon or PDB codes to get more information about
              a subcluster including list of ligands present in the representative
              structure.
            </p>
            <p>
              Select any structure by clicking the checkbox
              <i class="mr-1 ml-1 far fa-square"></i>. Selected structures are
              marked with
              <i class="mr-1 ml-1 text-success far fa-check-square"></i>.
              <br />All selected structures (max 12) will be listed in the
              <i>Analysis</i> box of the page (discussed further below).
            </p>
            <p>
              By clicking on the
              <span>
                <i class="fa fa-cloud-download"></i>
              </span>
              you submit to model your query sequence with the selected model. A
              <span class="text-success">
                <i class="fa fa-floppy-o"></i>
              </span>
              symbol will appear when the job has completed and the model is
              ready for download.
            </p>
            <h4>Ligands</h4>
            ModFlex.org allows to restrict model selection to those structures
            resolved with a ligand. Structures with a ligand are decorated with
            a
            <span>
              <i class="icofont-atom"></i>
            </span>
            symbol above. Clicking on the
            <button
              type="button"
              class="btn btn-sm ng-valid ng-not-empty ng-dirty ng-valid-parse btn-primary ng-touched"
              style
            >
              <i class="icofont-atom"></i> Has ligands
            </button>
            hides all structures without ligands.
            <h4>Heterocomplex</h4>
            ModFlex.org allows to restrict model selection to those models
            resolved in heterocomplex with other chains, indicated by
            <span>
              <i class="fa fa-cubes"></i>
            </span>
            for each structure.
            <h3>Analysis box</h3>
            After selecting a subset of structures from the table, ModFlex
            displays an comparison matrix of the complete selection to analyze
            the structural difference between all potential modeling templates.
            Moreover, for an in-detail view on all structures click on the
            <i>Open POSA</i>
            button that will forward you to a calculated multiple structure
            alignmnet of all and advanced tools for structural analysis.
            However, clicking on a matrix element / structure pair will display
            an animantion between the images of both structures.
            <h2>Legend</h2>
            <ul class="list-unstyled">
              <li>
                <span>
                  <i class="fa fa-cloud-download"></i>
                </span>
                &dash; Click to submit modeling job using this representative.
              </li>
              <li>
                <span class="text-success">
                  <i class="fa fa-floppy-o"></i>
                </span>
                &dash; Modeling job finished and model is ready for download.
              </li>
              <li>
                <span class="text-danger">
                  <i class="fa fa-exclamation-circle"></i>
                </span>
                &dash; Modeling job failed.
              </li>
              <li>
                <span>
                  <i class="fa fa-puzzle-piece"></i>
                </span>
                &dash; Cluster representative has ligand.
              </li>
              <li>
                <span>
                  <i class="fa fa-cubes"></i>
                </span>
                &dash; Cluster representative is part of the heterocomplex.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchResultsHelp",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
h2,
h3,
h4 {
  margin-top: 15px;
}
</style>
